import { CheckCircle2, ArrowRight } from "lucide-react";

const ANNELIZE_IMG = "/annelize.jpg";

const badges = ["NZQBA Member", "ICB International Member", "IRD Registered", "NZ-Wide & Remote"];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-[#F2F7F8]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="absolute -bottom-5 -left-5 w-2/3 h-2/3 rounded-md bg-[#10BFCB]/25 hidden sm:block" />
            <img
              src={ANNELIZE_IMG}
              alt="Annelize, founder of Virtual Bookkeeping"
              className="relative w-full max-w-md h-[500px] object-cover rounded-md border border-[#E1E8E9]"
              loading="lazy"
            />
          </div>

          <div className="order-1 lg:order-2">
            <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-[#0DA2AD]">
              Meet Annelize
            </h4>
            <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-[#10242B]">
              A bookkeeper who actually has your back
            </h2>
            <p className="mt-5 text-lg text-[#55636B]">
              Virtual Bookkeeping is led by Annelize — a responsive, detail-driven
              professional who treats your business like her own. Clients love
              that she's prompt, thorough, and genuinely invested in keeping their
              books in order and their money working smarter.
            </p>
            <p className="mt-4 text-[#55636B] leading-relaxed">
              Whether you're a sole trader, a growing trade business or a busy
              small company, you'll get clear communication, accurate numbers and
              honest advice — every time.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3">
              {badges.map((b) => (
                <div
                  key={b}
                  data-testid={`trust-badge-${b.toLowerCase().replace(/\s/g, "-")}`}
                  className="flex items-center gap-2 bg-white border border-[#E1E8E9] rounded-md px-4 py-3"
                >
                  <CheckCircle2 size={18} className="text-[#10BFCB] shrink-0" />
                  <span className="text-sm font-semibold text-[#10242B]">
                    {b}
                  </span>
                </div>
              ))}
            </div>

            <a
              href="#book"
              data-testid="about-cta"
              className="mt-9 inline-flex items-center gap-2 bg-[#E8791F] text-white font-semibold px-7 py-4 rounded-md hover:bg-[#CE6410] transition-colors"
            >
              Work with Annelize <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
